"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPersonalEditorialCategoryOrPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/* istanbul ignore file -- API */ /**
 * Fetch function that fetches data for personal editorial category or personal landing page from GraphQL.
 */ const getPersonalEditorialCategoryOrPage = async (param)=>{
    let { graphQlUrl, headers, pageId, previewMode, landingPageId } = param;
    const data = await (0, _fetching.fetchGraphql)({
        query: _queriesNet.personalEditorialCategoryOrPageQuery,
        url: graphQlUrl,
        variables: {
            pageId,
            landingPageId
        },
        headers: {
            ...headers,
            [_fetching.PREVIEW_MODE]: previewMode !== null && previewMode !== void 0 ? previewMode : false
        },
        ...previewMode ? {
            timeout: 30000
        } : null
    });
    var _data_application;
    const { personalEditorialLandingPage, personalEditorialPage, rootPersonalEditorialLandingPage } = (_data_application = data.application) !== null && _data_application !== void 0 ? _data_application : {};
    var _personalEditorialLandingPage_landingPageId;
    return {
        application: {
            editorialLandingPage: {
                ...personalEditorialLandingPage,
                __typename: 'EditorialLandingPage',
                landingPageId: (_personalEditorialLandingPage_landingPageId = personalEditorialLandingPage === null || personalEditorialLandingPage === void 0 ? void 0 : personalEditorialLandingPage.landingPageId) !== null && _personalEditorialLandingPage_landingPageId !== void 0 ? _personalEditorialLandingPage_landingPageId : '',
                themeItems: (0, _utils.filterOutCurrentCategory)({
                    pageId,
                    categories: rootPersonalEditorialLandingPage === null || rootPersonalEditorialLandingPage === void 0 ? void 0 : rootPersonalEditorialLandingPage.themeItems
                }).map((category)=>({
                        ...category,
                        __typename: 'EditorialLandingPage'
                    }))
            },
            editorialPage: personalEditorialPage
        }
    };
};
exports.getPersonalEditorialCategoryOrPage = getPersonalEditorialCategoryOrPage;
